import React, { useState } from 'react'
import { X, Shirt, Sparkles } from 'lucide-react'
import { ClothingDressingRoom } from './ClothingDressingRoom'
import { ClothingWardrobe } from './ClothingWardrobe'

/**
 * 服装中心 - 整合换装试衣间和服装衣柜
 */
export const ClothingHub = ({ character, onClose, onClothingChanged, onClothingGenerated }) => {
  const [activeTab, setActiveTab] = useState('dressingRoom') // 'dressingRoom' 或 'wardrobe'

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-dark-800/30 backdrop-blur-md rounded-lg w-full max-w-6xl max-h-[90vh] overflow-hidden border border-dark-600/30 flex flex-col shadow-2xl">
        {/* 头部 */}
        <div className="flex items-center justify-between p-6 border-b border-dark-600/30 bg-dark-800/20 backdrop-blur-md">
          <div className="flex items-center gap-4">
            <Shirt size={24} className="text-primary" />
            <h2 className="text-2xl font-bold text-white">
              {character?.name}的衣柜
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-dark-400 hover:text-white transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* 标签页切换 */}
        <div className="flex border-b border-dark-600/30 bg-dark-800/20 backdrop-blur-md px-6">
          <button
            onClick={() => setActiveTab('dressingRoom')}
            className={`px-6 py-3 font-medium transition-all relative ${
              activeTab === 'dressingRoom'
                ? 'text-primary'
                : 'text-dark-400 hover:text-dark-200'
            }`}
          >
            <div className="flex items-center gap-2">
              <Shirt size={18} />
              <span>试衣间</span>
            </div>
            {activeTab === 'dressingRoom' && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />
            )}
          </button>
          
          <button
            onClick={() => setActiveTab('wardrobe')}
            className={`px-6 py-3 font-medium transition-all relative ${
              activeTab === 'wardrobe'
                ? 'text-primary'
                : 'text-dark-400 hover:text-dark-200'
            }`}
          >
            <div className="flex items-center gap-2">
              <Sparkles size={18} />
              <span>虚拟衣柜</span>
            </div>
            {activeTab === 'wardrobe' && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />
            )}
          </button>
        </div>

        {/* 内容区域 */}
        <div className="flex-1 overflow-hidden">
          {activeTab === 'dressingRoom' ? (
            <ClothingDressingRoom
              character={character}
              onClose={onClose}
              onClothingGenerated={onClothingGenerated}
              isEmbedded={true}
            />
          ) : (
            <ClothingWardrobe
              character={character}
              onClose={onClose}
              onClothingChanged={onClothingChanged}
              isEmbedded={true}
            />
          )}
        </div>
      </div>
    </div>
  )
}

